(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/physical-tickets/components/physical-tickets-form/components/customer-information/components/deliver-date-latest-input.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/physical-tickets/components/physical-tickets-form/components/customer-information/components/deliver-date-latest-input.js');
"use strict";


const DateInput = svs.ui.reactFormInputs.DateInput;
const DELIVER_DATE_LATEST = svs.ticket_partner.physicalTickets.constants.names.DELIVER_DATE_LATEST;
const DELIVER_DATE_LATEST_LABEL = svs.ticket_partner.physicalTickets.constants.FORMS.DELIVER_DATE_LATEST.DELIVER_DATE_LATEST_LABEL;
const DeliverLatestInput = _ref => {
  let handleChange = _ref.handleChange,
    state = _ref.state;
  return React.createElement(DateInput, {
    id: DELIVER_DATE_LATEST,
    isRequired: false,
    label: DELIVER_DATE_LATEST_LABEL,
    name: DELIVER_DATE_LATEST,
    onChange: handleChange,
    value: state[DELIVER_DATE_LATEST]
  });
};
svs.ticket_partner.physicalTickets.physicalTicketsForm.customerInformation.components.DeliverLatestInput = DeliverLatestInput;

 })(window);